import { LegacyCategoryType } from 'js/src/server-middleware/categoryRepository'
import { Author, IdeationStatus, FeaturedTopicFromUnified } from '../../services/unified'
import { UserData } from '../event/EventAttendees'

export type ContentType =
  | 'conversation'
  | 'question'
  | 'article'
  | 'productUpdate'
  | 'idea'
  | 'event'

export interface Post {
  id?: number
  author: Author
  content: string
  creationDate: string
  relativeCreationDate: string
}

export interface FeaturedEvent {
  title: string
  url: string
  type?: string
  startsAt: number
  endsAt: number
  image?: string
  location?: string
  contentType: 'event'
  lastActivityAt: string
  isLoggedInUserAttendee: boolean
  attendees?: UserData[]
  attendeeCount?: number
}

export interface FeaturedTopic {
  id: number
  title: string
  description: string
  url: string
  type: LegacyCategoryType
  featuredImage: string
  label: string
  replyCount: number
  views: number
  post: Post
  customClass: string
  likes: number
  hasCurrentUserLiked: boolean
  ideationStatus?: IdeationStatus
  contentType: 'conversation' | 'question' | 'article'
}

export type AnyFeaturedTopic = FeaturedTopic | FeaturedTopicFromUnified | FeaturedEvent

export const isUnified = (topic: AnyFeaturedTopic): topic is FeaturedTopicFromUnified => {
  return 'publicId' in topic
}

export const isLegacyFeaturedTopic = (topic: AnyFeaturedTopic): topic is FeaturedTopic => {
  return 'type' in topic
}

export const isEvent = (topic: AnyFeaturedTopic): topic is FeaturedEvent => {
  return topic.contentType === 'event'
}
